import { httpClient } from '@/infra/protocols/http';
import { IHostVoiceDTO } from '@/modules/episodes/dtos/host.dto';
import { IHostVoice } from '@/modules/episodes/entities/host.entity';
import { HostMapper } from '@/modules/episodes/mappers/host.mapper';

export async function getHosts(params: GetHostsService.Params): Promise<GetHostsService.Response> {
  const response = await httpClient.get<IHostVoiceDTO[]>(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/episodios/${params.episodeId}/hosts`,
  );

  return response.map(HostMapper.toPresentation);
}

export namespace GetHostsService {
  export interface Params {
    projectId: string;
    podcastId: string;
    episodeId: string;
  }
  export type Response = IHostVoice[];
}
